import { FC } from 'react';
import { Avatar, TableRow, Tooltip } from '@mui/material';

import { ContentMetricDataPoint } from './DataPointTable';
import dayjs from 'dayjs';
import { CustomTableCell } from '../../components/Table/TableCell';
import { CustomTableActions } from '../../components/Table/TableActions';

type ContentMetricDataPointWithMetricDataPoint = Omit<ContentMetricDataPoint, 'metricDataPoint'> & {
	metricDataPoint: NonNullable<ContentMetricDataPoint['metricDataPoint']>;
};

type Props = Readonly<{
	contentMetricDataPoint: ContentMetricDataPointWithMetricDataPoint;
	onUpdate: () => void;
	onDelete: () => void;
}>;

const DataPointTableRow: FC<Props> = ({ contentMetricDataPoint, onUpdate, onDelete }) => {
	return (
		<TableRow hover key={contentMetricDataPoint.id} sx={{ '.MuiTableCell-root': { paddingX: 1.5, paddingY: 0.25 } }}>
			<CustomTableCell>
				<Tooltip title={contentMetricDataPoint.creator?.name} arrow>
					<Avatar
						variant={'circular'}
						sx={{
							width: 24,
							height: 24,
							':hover': {
								borderRadius: 6,
								outline: (theme) => `1px solid ${theme.palette.primary[400]}`,
								outlineOffset: 2,
							},
						}}
						src={contentMetricDataPoint.creator?.avatar?.url ?? ''}
						alt={contentMetricDataPoint.creator?.name ?? ''}
					/>
				</Tooltip>
			</CustomTableCell>

			<CustomTableCell>{dayjs(contentMetricDataPoint.createdAt).format('lll')}</CustomTableCell>

			<CustomTableCell
				content={`${dayjs(contentMetricDataPoint.metricDataPoint.start).format('ll')} – 
				${
					contentMetricDataPoint.metricDataPoint.end == null
						? '∞'
						: dayjs(contentMetricDataPoint.metricDataPoint.end).subtract(1, 'day').format('ll')
				}`}
			/>

			<CustomTableCell>{contentMetricDataPoint.metricDataPoint.value.toString()}</CustomTableCell>

			<CustomTableCell isActionButton>
				<CustomTableActions openEdit={() => onUpdate()} onDelete={() => onDelete()} />
			</CustomTableCell>
		</TableRow>
	);
};

export { DataPointTableRow };
